import { IFormErrors } from '@interfaces/IFormsErrors';
import { IStudentResults } from '@interfaces/IStudentResults';

export interface IStudentResultsViewState {
  results: IStudentResults | null;
  isLoading: boolean;
  errors: IFormErrors | null;
}

export const initialsStudentResultsViewState: IStudentResultsViewState = {
  results: null,
  isLoading: false,
  errors: null,
};
